import {BaseCaller} from './api';

export default class AdminApi {

    private caller: BaseCaller;

    constructor(caller: BaseCaller) {
        this.caller = caller;
    }

    public list(): Promise<any> {
        return this.caller.get('admin/');
    };


    add(data: { name: string; pass: string; email: string }) {
        return this.caller.post('admin/', data);
    }

    update(data: { name: string; email: string }, id: number) {
        return this.caller.put('admin/' + id.toString(), data);
    }

    changePassword(id: number, password: string) {
        return this.caller.put(`admin/${id}/password`, { password });
    }

    disable(id: string) {
        return this.caller.post(`admin/${id}/inactivate`, {});
    }

    clientLocationByDocument(document: string): Promise<any>{
        return this.caller.get(`admin/location/byClientDocument/${document}`)
    }

    adminToDriver(id: number) {
        return this.caller.put(`admin/${id}/toDriver`, {})
    }
}



// WEBPACK FOOTER //
// ./src/api/admin-api.ts